"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var operators_1 = require("rxjs/operators");
var constants_1 = require("../constants");
var engagement_event_types_constant_1 = require("../constants/engagement-event-types.constant");
var review_pro_rating_1 = require("../constants/review-pro-rating");
var services_1 = require("../generated/services");
var dealer_service_1 = require("./dealer.service");
var http_interceptor_options_service_1 = require("./http/http-interceptor-options.service");
var notification_service_1 = require("./notification.service");
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("./notification.service"));
var i2 = __importStar(require("../generated/services/deal-sheet-client.service"));
var i3 = __importStar(require("./dealer.service"));
var i4 = __importStar(require("./http/http-interceptor-options.service"));
var CustomerEngagementService = /** @class */ (function () {
    function CustomerEngagementService(notificationService, dealSheetClient, dealerService, httpInterceptorOptionsService) {
        this.notificationService = notificationService;
        this.dealSheetClient = dealSheetClient;
        this.dealerService = dealerService;
        this.httpInterceptorOptionsService = httpInterceptorOptionsService;
    }
    CustomerEngagementService.prototype.getCustomerEngagementLastViewed = function () {
        return this.dealSheetClient.GetCustomerEngagementLastViewedGET().toPromise();
    };
    Object.defineProperty(CustomerEngagementService.prototype, "newEngagements", {
        get: function () {
            return this.notificationService.message$
                .pipe(operators_1.filter(function (evt) { return evt.eventType == notification_service_1.EventTypes.engagement; }));
        },
        enumerable: true,
        configurable: true
    });
    CustomerEngagementService.prototype.getCustomerEngagement = function (hoursBack) {
        var _this = this;
        var dateFrom = moment_1.default().subtract(hoursBack || 24, "hours").toDate();
        var params = {
            dateFrom: dateFrom.toISOString().replace("Z", ""),
            lastViewedDate: undefined,
            IncludeReviewPro: false
        };
        var result = this.dealSheetClient.GetCustomerEngagementLastViewedGET().toPromise()
            .then(function (lastViewedResponse) {
            params.lastViewedDate = (lastViewedResponse !== null) ?
                lastViewedResponse.lastViewedDateUTC :
                new Date();
            return _this.dealerService.getIsAssetEnabledForDealer(constants_1.AssetTypes.reviewBuilderPro)
                .then(function (response) {
                params.IncludeReviewPro = response;
                return _this.dealSheetClient.CustomerEngagementHistoryGET(params).toPromise()
                    .then(function (engagementsResponse) {
                    return {
                        engagements: engagementsResponse,
                        lastViewed: lastViewedResponse
                    };
                });
            });
        })
            .then(function (combinedResponse) {
            if (!combinedResponse) {
                return { lastViewed: null, engagements: null };
            }
            var lastViewed = combinedResponse.lastViewed;
            var engagements = combinedResponse.engagements;
            return {
                lastViewedDate: lastViewed && lastViewed.data && lastViewed.data.lastViewedDateUTC
                    ? moment_1.default.utc(lastViewed.data.lastViewedDateUTC).local().toDate()
                    : null,
                engagements: engagements.map(function (item) { return ({
                    customerFullName: item.customerFullName,
                    engagementEventGroupId: item.engagementEventGroupID,
                    engagementEventTypeId: item.engagementEventTypeID,
                    eventDate: _this.utcStringToLocalDate(item.eventDateUTC),
                    reviewRating: item.reviewRating,
                    highEngagement: item.highEngagement,
                    opportunityId: item.entityId,
                    group: lodash_1.invert(engagement_event_types_constant_1.EngagementEventGroups)[item.engagementEventGroupID],
                    one2oneCount: item.one2OneCount,
                    emailCount: item.emailCount,
                    textMessageCount: item.textMessageCount,
                    autoAssistantCount: item.autoAssistantCount,
                    webCount: item.webCount,
                    serviceCount: item.serviceCount,
                    reviewCount: item.reviewCount,
                    totalCount: item.one2OneCount + item.emailCount + item.webCount + item.serviceCount + item.reviewCount + item.textMessageCount + item.autoAssistantCount + item.intelligentMarketingCount + item.geoAlertCount,
                    lastViewedCount: item.lastViewedCount,
                    ratingIcon: review_pro_rating_1.RATING_ICONS[item.reviewRating],
                    ratingTitle: review_pro_rating_1.RATING_TITLES[item.reviewRating],
                    intelligentMarketingCount: item.intelligentMarketingCount,
                    geoAlertCount: item.geoAlertCount
                }); })
            };
        });
        return result;
    };
    CustomerEngagementService.prototype.getCustomerEngagementByGroup = function (selectedDealerId, _a) {
        var _this = this;
        var engagementEventGroupIds = _a.engagementEventGroupIds, dateFrom = _a.dateFrom, take = _a.take, hotLeadsOnly = _a.hotLeadsOnly, notWorkedOnly = _a.notWorkedOnly, dealerId = _a.dealerId;
        var params = {
            engagementEventGroupIds: engagementEventGroupIds,
            dateFrom: dateFrom ? moment_1.default(dateFrom).utc().toISOString() : undefined,
            take: take || 100,
            hotLeadsOnly: !!hotLeadsOnly,
            notWorkedOnly: !!notWorkedOnly,
            dealerId: dealerId
        };
        this.httpInterceptorOptionsService.setOverrideDealerIds([selectedDealerId]);
        var result = this.dealSheetClient.CustomerEngagementDashboardPOST(params).toPromise()
            .then(function (response) { return response.map(function (engagement) { return (__assign({}, engagement, { entityID: engagement.entityId, opportunityId: engagement.entityId, eventDate: _this.utcStringToLocalDate(engagement.eventDateUTC), ratingIcon: review_pro_rating_1.RATING_ICONS[engagement.reviewRating], ratingTitle: review_pro_rating_1.RATING_TITLES[engagement.reviewRating] })); }); });
        return result;
    };
    // This returns engagements for an Entity with eventDate, engagementEventTypeID
    // and highEngagement.
    CustomerEngagementService.prototype.getCustomerEngagementsByEntity = function (entityId, dateFrom, hotLeadsOnly) {
        var _this = this;
        var params = {
            entityId: entityId,
            dateFrom: dateFrom ? moment_1.default(dateFrom).utc().toISOString() : undefined,
            hotLeadsOnly: hotLeadsOnly
        };
        var result = this.dealSheetClient.CustomerEngagementsByEntityPOST(params).toPromise()
            .then(function (response) { return response.map(function (engagement) { return ({
            engagementEventTypeId: engagement.engagementEventTypeID,
            engagementEventGroupId: engagement.engagementEventGroupID,
            eventDate: _this.utcStringToLocalDate(engagement.eventDateUTC),
            reviewRating: engagement.reviewRating,
            highEngagement: engagement.highEngagement,
            ratingIcon: review_pro_rating_1.RATING_ICONS[engagement.reviewRating],
            ratingTitle: review_pro_rating_1.RATING_TITLES[engagement.reviewRating]
        }); }); });
        return result;
    };
    CustomerEngagementService.prototype.markCustomerEngagementsViewed = function () {
        return this.dealSheetClient.UpdateCustomerEngagementLastViewedPOST().toPromise();
    };
    CustomerEngagementService.prototype.utcStringToLocalDate = function (str) {
        return moment_1.default.utc(str).local().toDate();
    };
    CustomerEngagementService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomerEngagementService_Factory() { return new CustomerEngagementService(i0.ɵɵinject(i1.NotificationService), i0.ɵɵinject(i2.DealSheetClientService), i0.ɵɵinject(i3.DealerService), i0.ɵɵinject(i4.HttpInterceptorOptionsService)); }, token: CustomerEngagementService, providedIn: "root" });
    return CustomerEngagementService;
}());
exports.CustomerEngagementService = CustomerEngagementService;
